<template>
  <div>
    <template v-if="welcome_quickreplies">
      <v-layout>
        <v-flex
          v-if="showMultipleChannel"
          class="channel"
          shrink
          style="border-right: 1px solid #eee"
        >
          <div
            :class="{ 'primary white--text': tab == 'facebook' }"
            @click="tab = 'facebook'"
            class="py-1 pl-2 pr-2"
            style="
              border: 1px solid #eee;
              border-width: 1px 0px 1px 1px;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              cursor: pointer;
            "
          >
            <span class="fab fa-facebook"></span>
          </div>
          <div
            :class="{ 'primary white--text': tab == 'line' }"
            @click="tab = 'line'"
            class="py-1 pl-2 pr-2"
            style="
              border: 1px solid #eee;
              border-width: 1px 0px 1px 1px;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              cursor: pointer;
            "
          >
            <span class="fab fa-line"></span>
          </div>
          <div
            :class="{ 'primary white--text': tab == 'ig' }"
            @click="tab = 'ig'"
            class="py-1 pl-2 pr-2"
            style="
              border: 1px solid #eee;
              border-width: 1px 0px 1px 1px;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              cursor: pointer;
            "
          >
            <span class="fab fa-instagram"></span>
          </div>
        </v-flex>
        <v-flex class="pl-1">
          <template v-if="isEdit">
            <template v-if="!showMultipleChannel">
              <div class="form-control" :class="{ 'has-error': errorTag['replies'].length > 0 }">
                <tags
                  v-model="reply"
                  :tags="replies"
                  @tags-changed="addReplies('replies', $event)"
                  @before-adding-tag="checkQuickReply('replies', $event)"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add choice')"
                ></tags>
              </div>
            </template>
            <template v-else>
              <div class="form-control" :class="{ 'has-error': errorTag[tab].length > 0 }">
                <tags
                  v-model="reply"
                  :tags="tab == 'facebook' ? fb_replies : tab == 'line' ? line_replies : ig_replies"
                  @tags-changed="addReplies(tab, $event)"
                  @before-adding-tag="checkQuickReply(tab, $event)"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add choice')"
                ></tags>
              </div>
            </template>
            <div class="form-control has-error">
              <template v-for="(error, errorKey) in errorTag">
                <span :key="errorKey" class="text-error" v-if="error.length > 0">
                  <template v-if="error.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="error.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="error.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="quickreply">
              <ul class="tags">
                <template v-if="tab == 'all'">
                  <li class="tag" v-for="(reply, index) in replies" :key="'reply_' + index">
                    {{ reply.text }}
                  </li>
                  <div class="pl-2 primary--text" v-if="replies.length == 0">
                    {{ $t('No quick reply') }}
                  </div>
                </template>
                <template v-else-if="tab == 'facebook'">
                  <li class="tag" v-for="(reply, index) in fb_replies" :key="'reply_' + index">
                    {{ reply.text }}
                  </li>
                  <div class="pl-2 primary--text" v-if="fb_replies.length == 0">
                    {{ $t('No quick reply') }}
                  </div>
                </template>
                <template v-else-if="tab == 'line'">
                  <li class="tag" v-for="(reply, index) in line_replies" :key="'reply_' + index">
                    {{ reply.text }}
                  </li>
                  <div class="pl-2 primary--text" v-if="line_replies.length == 0">
                    {{ $t('No quick reply') }}
                  </div>
                </template>
                <template v-else-if="tab == 'ig'">
                  <li class="tag" v-for="(reply, index) in ig_replies" :key="'reply_' + index">
                    {{ reply.text }}
                  </li>
                  <div class="pl-2 primary--text" v-if="ig_replies.length == 0">
                    {{ $t('No quick reply') }}
                  </div>
                </template>
              </ul>
            </div>
          </template>
        </v-flex>
      </v-layout>
      <div class="text-xs-center" style="margin-top: 25px; margin-bottom: 25px">
        <template v-if="isEdit">
          <slot name="footer" :cancelEdit="cancelEdit" :saveContent="saveContent">
            <v-btn color="grey" outline @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" depressed @click="saveContent">{{ $t('Save') }}</v-btn>
          </slot>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

import VueTagsInput from '@johmun/vue-tags-input'
import FacebookScreen from '@/components/elements/FacebookScreen'
import Tags from '@/components/elements/Tags'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: ['value', 'isEdit', 'showMultipleChannel'],
  data: function () {
    return {
      welcome_quickreplies: undefined,
      tag: '',
      tab: 'all',
      reply: '',

      errorTag: {
        replies: [],
        facebook: [],
        line: [],
        ig: []
      }
    }
  },
  components: {
    FacebookScreen,
    VueTagsInput,
    Tags
  },
  created: function () {
    this.welcome_quickreplies = cloneDeep(this.value)
    this.cached_welcome_quickreplies = cloneDeep(this.value)
    if (this.showMultipleChannel) {
      this.tab = 'facebook'
    } else {
      this.tab = 'all'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    replies: {
      get() {
        var vm = this
        if (
          vm.welcome_quickreplies &&
          vm.welcome_quickreplies.replies &&
          vm.welcome_quickreplies.replies != null &&
          vm.welcome_quickreplies.replies != ''
        ) {
          var tags = vm.welcome_quickreplies.replies.split(',')
          var result = []
          try {
            result = tags.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          this.$emit('onChangeChoice', result)
          return result
        } else {
          this.$emit('onChangeChoice', [])
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        try {
          result = value.map((val) => {
            return val.text
          })
        } catch (error) {}
        vm.welcome_quickreplies.replies = result.join(',')
      }
    },
    fb_replies: {
      get() {
        var vm = this
        if (
          vm.welcome_quickreplies &&
          vm.welcome_quickreplies.facebook &&
          vm.welcome_quickreplies.facebook != null &&
          vm.welcome_quickreplies.facebook != ''
        ) {
          var tags = vm.welcome_quickreplies.facebook.split(',')
          var result = []
          try {
            result = tags.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          this.$emit('onChangeChoice', result)
          return result
        } else {
          this.$emit('onChangeChoice', [])
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        try {
          result = value.map((val) => {
            return val.text
          })
        } catch (error) {}
        vm.welcome_quickreplies.facebook = result.join(',')
      }
    },
    line_replies: {
      get() {
        var vm = this
        if (
          vm.welcome_quickreplies &&
          vm.welcome_quickreplies.line &&
          vm.welcome_quickreplies.line != null &&
          vm.welcome_quickreplies.line != ''
        ) {
          var tags = vm.welcome_quickreplies.line.split(',')
          var result = []
          try {
            result = tags.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          this.$emit('onChangeChoice', result)
          return result
        } else {
          this.$emit('onChangeChoice', [])
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        try {
          result = value.map((val) => {
            return val.text
          })
        } catch (error) {}
        vm.welcome_quickreplies.line = result.join(',')
      }
    },
    ig_replies: {
      get() {
        var vm = this
        if (
          vm.welcome_quickreplies &&
          vm.welcome_quickreplies.ig &&
          vm.welcome_quickreplies.ig != null &&
          vm.welcome_quickreplies.ig != ''
        ) {
          var tags = vm.welcome_quickreplies.ig.split(',')
          var result = []
          try {
            result = tags.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          this.$emit('onChangeChoice', result)
          return result
        } else {
          this.$emit('onChangeChoice', [])
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        try {
          result = value.map((val) => {
            return val.text
          })
        } catch (error) {}
        vm.welcome_quickreplies.ig = result.join(',')
      }
    }
  },
  methods: {
    addReplies: function (type, newTags) {
      if (type == 'facebook') this.fb_replies = newTags
      else if (type == 'line') this.line_replies = newTags
      else if (type == 'ig') this.ig_replies = newTags
      else this.replies = newTags
    },
    checkQuickReply: function (type, obj) {
      this.errorTag[type] = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        this.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (
        obj.type == 'add' &&
        ((type == 'replies' && this.replies.length >= 10) ||
          (type == 'facebook' && this.fb_replies.length >= 10) ||
          (type == 'line' && this.line_replies.length >= 10) ||
          (type == 'ig' && this.ig_replies.length >= 10))
      ) {
        this.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    cancelEdit: function () {
      var vm = this
      this.welcome_quickreplies = cloneDeep(this.cached_welcome_quickreplies)

      vm.$emit('input', Object.assign({}, this.welcome_quickreplies))
      vm.$emit('onCancel')
    },
    saveContent: async function () {
      var vm = this
      try {
        var content = {
          contenttype: 'welcome_quickreplies',
          contentvalue: this.welcome_quickreplies.replies,
          datatype: 'textarea',
          pageid: this.selectedBot.pageid
        }
        await vm.sendRequest(content)
      } catch (error) {}
      this.cached_welcome_quickreplies = cloneDeep(this.welcome_quickreplies)
      vm.$emit('input', this.welcome_quickreplies)
      vm.$emit('onSave', this.welcome_quickreplies)
    },
    sendRequest: function (content) {
      var vm = this
      return new Promise((resolve) => {
        api.updateConfig(content, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  },
  watch: {
    showMultipleChannel: function (newVal, oldVal) {
      if (newVal) {
        this.tab = 'facebook'
      } else {
        this.tab = 'all'
      }
    },
    value: function () {
      this.welcome_quickreplies = cloneDeep(this.value)

      this.cached_welcome_quickreplies = cloneDeep(this.value)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/chatbot/QuickReply.vue